<template>
    <Dialog
      :visible="true"
      modal
      :style="{ width: '35rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
      :draggable="false"
      :closable="false"
      class="jf-auth-dialog relative bg-white rounded-lg"
    >
      <h1 class="text-2xl font-bold text-center text-oxford-blue">{{ translate('choose your profile', 'ucfirst') }}</h1>

      <p class="jf-auth-dialog__intro">{{ translate('select how you want to use Jobifull', 'ucfirst') }}</p>
      <div class="jf-profile-options grid mt-5">
        <Button 
          v-if="canDisplay('professional')"
          type="button"
          :label="translate('professional', 'ucfirst')" 
          icon="pi pi-user" 
          iconPos="right" 
          class="jf-profile-option py-2 px-5 text-white rounded-lg bg-sea-serpent mt-5 col-span-3"
          @click.prevent="performAction('professional')"
        />
        <Button 
          v-if="canDisplay('recruiter')"
          type="button"
          :label="translate('recruiter', 'ucfirst')" 
          icon="pi pi-clipboard" 
          iconPos="right" 
          class="jf-profile-option py-2 px-5 text-white rounded-lg bg-sea-serpent mt-5 col-span-3"
          @click.prevent="performAction('recruiter')"
        />
        <Button 
          v-if="canDisplay('company')"
          type="button"
          :label="translate('company', 'ucfirst')" 
          icon="pi pi-building" 
          iconPos="right" 
          class="jf-profile-option py-2 px-5 text-white rounded-lg bg-sea-serpent mt-5 col-span-3"
          @click.prevent="performAction('company')"
        />
      </div>
    </Dialog>
</template>

<script setup>
  import Dialog from "primevue/dialog";
  import Button from "primevue/button";
  import store from "@/store";
  import requestHandler from "@/composables/requestHandler";
  import Cookies from "js-cookie";
  import { encrypte } from "@/composables/crypto";
  import { translate } from "@/composables/translate";
  import { getRegistrationProfile } from "@/composables/registrationProfiles.mjs";

  const props = defineProps({
    action: {
      type: String,
      required: false,
      default: 'login'
    }
  });

  async function performAction(profileName = ''){
    switch(props.action){
      case 'login':
        await loginOnProfile(profileName);
      break;
      case 'register':
        return emitProfileChosen(profileName);
      case 'switchAccount':
        await changeProfile(profileName);
      break;
    }
  }

  async function loginOnProfile(profileName = ''){
    let userProfiles = store.getters.getUserType;
    if(!userProfiles.includes(profileName))
        profileName = 'profile';
    store.commit('setLoggedAs', profileName);
    Cookies.set('last_login_as', encrypte(profileName));
    let urlToGo = store.getters.getRouteToGoAfterLogin;
    if(urlToGo !== null){
      store.dispatch('saveRouteToGoAfterLogin', {url: null});
      await requestHandler.redirect(urlToGo);
      return;
    }
    if(profileName === 'professional') {
      await requestHandler.redirect(`/dashboard/${store.getters.getLoggedAs}/${store.getters.getUserSlug}/preview/curriculum`);
    } else {
      await requestHandler.redirect(`/dashboard/${store.getters.getLoggedAs}/${store.getters.getUserSlug}`);
    }
  }

  async function changeProfile(profileName = ''){
    let userProfiles = store.getters.getUserType;
    if(!userProfiles.includes(profileName))
        profileName = 'profile';
    store.commit('setLoggedAs', profileName);
    Cookies.set('last_login_as', encrypte(profileName));
    emitProfileChosen(profileName);
    await requestHandler.redirect(`/dashboard/${store.getters.getLoggedAs}/${store.getters.getUserSlug}`);
  }

  const emit = defineEmits({
    click: null,
    profileChosen: ({ profileName }) => {
      return profileName;
    }
  })

  function emitProfileChosen(profileName = ''){
    const selectedProfile = {
      app: profileName,
      api: getRegistrationProfile(profileName)
    }
    if(!selectedProfile.api)
      return false;
    emit('profileChosen', { profileName: selectedProfile })
    return true;
  }

  function canDisplay(name = ''){
    let myProfiles = store.getters.getLoggedUserNotLoggedInProfile;
    let loggedAs = store.getters.getLoggedAs;
    let display = false;
    switch(props.action){
      case 'register':
        display = true;
      break;
      case 'switchAccount':
        if(myProfiles.length < 1 || name == loggedAs || !myProfiles.includes(name)){
          display = false;
        }else{
          display = true;
        }
      break;
      case 'login':
        if(name == 'professional' && store.getters.getProfessional != null){
          display = true;
        }
        if(name == 'company' && store.getters.getCompany != null){
          display = true;
        }
        if(name == 'recruiter' && store.getters.getRecruiter != null){
          display = true;
        }
      break;
    }
    return display;
  }
</script>
